// import * as api from 'storeapi';
// import {loadAMCState} from 'storelocalStorage';

import * as CONST from "actions/action_constants";

export const requestAccountManager = () => ({
  type: CONST.ACCOUNT_MANAGER_REQUEST
});
